import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    taskImages: [],
    userEmail: localStorage.getItem('userEmail') || ''
  },
  getters: {
  },
  mutations: {
    setTaskImages (state, taskImages) {
      state.taskImages = taskImages
    },
    setUserEmail (state, email) {
      state.userEmail = email
      localStorage.setItem('userEmail', email)
    },
    clearUserEmail (state) {
      state.userEmail = ''
      localStorage.removeItem('userEmail')
    }
  },
  actions: {
  },
  modules: {
  }
})
